module.exports = __webpack_public_path__ + "img/logo-icon.5814d53e.svg";